import PropTypes from 'prop-types';
import React from 'react';

import BackstageLayout from '../BackstageLayout/BackstageLayout';

export const BackstageLayout2 = props => {
  const layoutProps = {
    entityGetterFunc: props.entityGetterFunc,
    entityIdentifier: props.entityIdentifier,
    hasCuratorPrograms: props.hasCuratorPrograms,
    headerProps: props.headerProps,
    heroImageHasRings: props.heroImageHasRings,
    heroImageIsCircle: props.heroImageIsCircle,
    heroImageLinkUrl: props.heroImageLinkUrl,
    heroImageUrl: props.heroImageUrl,
    isHeaderInSidebar: props.isHeaderInSidebar,
    pandoraId: props.pandoraId,
    playOnClick: props.playOnClick,
    renderArtworkPlayButton: props.renderArtworkPlayButton,
    renderMainContent: () => props.mainContent,
    renderSidebarButtons: () => props.sidebarButtons,
    renderStructuredMetaData: () => props.structuredMetaData,
  };

  return <BackstageLayout {...layoutProps} />;
};

BackstageLayout2.propTypes = {
  // Original backstage pages used an seoToken parsed from the URL. Newer pages use the pandoraId associated with an entity
  // The `entityGetterFunc` will be called with `entityIdentifier` to retrieve data to render.
  entityGetterFunc: PropTypes.func,
  entityIdentifier: PropTypes.string,
  hasCuratorPrograms: PropTypes.bool,
  headerProps: PropTypes.shape({
    title: PropTypes.string,
    titleUrl: PropTypes.string,
    subTitleLrg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subTitleSm: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  heroImageHasRings: PropTypes.bool,
  heroImageIsCircle: PropTypes.bool,
  heroImageLinkUrl: PropTypes.string,
  heroImageUrl: PropTypes.string,
  isHeaderInSidebar: PropTypes.bool,
  mainContent: PropTypes.node.isRequired,
  pandoraId: PropTypes.string,
  playOnClick: PropTypes.func,
  renderArtworkPlayButton: PropTypes.bool,
  sidebarButtons: PropTypes.node,
  structuredMetaData: PropTypes.node,
};

export default BackstageLayout2;
